import React, { useState, useEffect, useCallback, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string } from 'prop-types';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { params, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { EMTPlaceholder } from './EMTPlaceholder.component';
import { LinkSets } from './LinkSets';
import './emt-links.scss';

const EmtLinksComponent = ({ path }) => {
  const { isServer } = useContext(ExperienceContext);
  let linkSets = [];
  let headerLocation = 'Explore More on homedepot.com';

  const defaultRender = () => {
    return null;
  };

  const pathname = path.replace(/render-\w+\//, '');
  const options = {
    ssr: true,
    variables: { path: pathname }
  };

  const { loading, error, data } = useDataModel('emtLinks', options);

  // SEOIM-44: do we want to update new relic to emt as well?
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('seo-links.ready'); }, []);

  const [showMore, setOverlay] = useState(isServer);
  const toggleOverlay = useCallback(() => {
    setOverlay((seeMore) => !seeMore);
  }, []);

  if (!path) return defaultRender();

  if (loading) {
    return (
      <EMTPlaceholder
        color="#E0E0E0"
        showLoadingAnimation
      />
    );
  }

  if ((error && !data) || !data?.emtLinks) {
    return null;
  }

  try {
    let emtLinks = JSON.parse(data.emtLinks);
    linkSets = emtLinks?.sets || [];
    headerLocation = emtLinks?.heading || 'Explore More on homedepot.com';
  } catch (err) {
    return defaultRender();
  }

  if (linkSets.length === 0) {
    return defaultRender();
  }
  return (
    <div className="col__12-12">
      <div className={
        showMore ? 'emt-links' : 'emt-links collapsed'
      }
      >
        <h2 className="emt-links-heading">{headerLocation}</h2>
        <LinkSets sets={linkSets} />
        <div className="emt-links__more__overlay">
          <img
            src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
            alt="more link"
            className="emt-links__more__icon"
            height="auto"
            width="auto"
          />
          <button className="emt-links__more__toggle" href="#" onClick={toggleOverlay} type="button">
            <span>{showMore ? 'View Less' : 'View More'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

EmtLinksComponent.displayName = 'EmtLinks';

const dataModel = {
  emtLinks: params({ path: stringType() }).string()
};

const propTypes = {
  path: string.isRequired
};
EmtLinksComponent.propTypes = propTypes;

const HydratedEMTLinks = withHydrator({
  id: 'emt-links',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (
    <EMTPlaceholder
      color="#E0E0E0"
      showLoadingAnimation
    />
  )
}, EmtLinksComponent);
const DynamicEmtLinks = withDynamicComponent(HydratedEMTLinks);
const EmtLinksLayoutGroup = withLayoutGroup({ name: 'emt-links' }, DynamicEmtLinks);
export const EmtLinks = EmtLinksLayoutGroup;

EmtLinks.propTypes = propTypes;
EmtLinks.dataModel = dataModel;
